import { render, staticRenderFns } from "./CustomizeInsideTheBox.vue?vue&type=template&id=27180bd2&scoped=true&"
import script from "./CustomizeInsideTheBox.vue?vue&type=script&lang=js&"
export * from "./CustomizeInsideTheBox.vue?vue&type=script&lang=js&"
import style0 from "./CustomizeInsideTheBox.vue?vue&type=style&index=0&id=27180bd2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27180bd2",
  null
  
)

export default component.exports